// IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B): чистая логика утверждения планов ЗП / DO из отчёта
// «Баланс постачання та попиту» (прототип handoff-tools/2026-10-30/plan_approval_proto, контракт бэка — plan.md §4, BE PR #979, common_modules/plan_approval_v3):
//   1) кнопка «Plan approval» шапки (AttrGrid.planApproval_button): чипы по видам планов (PURCHASE-PLAN / DISTR-PLAN) из plan_decision_summary, цвет — худший state,
//      меню по видам: Approve / Processed until… / Confirm (approved-changed) / Withdraw / History; скоуп {objects, segment} — позиции отбора отчёта;
//   2) раздел «PLAN DECISION» формы ячейки строки плана (Dropdown): состояние ключа (последнее событие plan_decision_history), радио Approve whole horizon /
//      Processed until date / Withdraw, причина (PLAN-DECISION-REASON), комментарий; скоуп {where, month} — как у cell_passport;
//   3) пилюля статуса и замок в заголовке строки плана: decision строки (DS-PLAN-DOCS — этап C бэка, поля ещё нет), иначе сводка вида плана с ОДНОЙ позицией в отборе.
//      IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком): decision_state / decision_until строки (DS-PLAN-DOCS),
//      иначе summary.by_key[plan_doc_id], иначе прежнее; отказ хотя бы по одной позиции — ничего не записано (окно без действия), partial, version_not_in_pm — текстом (plan.md §7).
// Любая запись — сначала plan_decision с dry: true (список позиций), подтверждение, затем настоящий вызов (planApproval_decide).
// Без Vue / DOM — юнит-тест tests/unit/planApproval.test.mjs. Флаг fe.ux.planApproval (дефолт ВКЛ с 04.11 — ie-dm7 #129874; явный false — ни кнопки, ни раздела, ни пилюли).   // IE 2026 11 04 / ODOO-5800 (слово Игоря через ie-dm7 #129874: дефолт ВКЛ; замок v2 — why из may_decide)
import { t, tn } from '@/i18n'
import { readLight_record } from '@/utils/readMethodLight'   // IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки)

export const PLAN_APPROVAL_FLAG = 'fe.ux.planApproval'
export const SEGMENTS = ['PURCHASE-PLAN', 'DISTR-PLAN']
export const METHODS = { decide: 'plan_decision', summary: 'plan_decision_summary', history: 'plan_decision_history' }

// IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки)
// Лёгкий запрос сводки / истории. Замер p269 (dev02, Баланс, 11 позиций): запрос plan_decision_summary 855 КБ, ответ 7 КБ, 1–1,2 с — тело почти целиком запись виджета (раскладка DL2,
// колонки viewList, оформление — как у signal_chains_batch, utils/readMethodLight.js). Что бэк читает (origin/main-2024-12, common_modules/widgets.widget_REPORT2.plan_decision_summary /
// plan_decision_history → plan_approval_v3.summary / history): params (objects | where | scope, version, segments); WIDGET.workspace_record (params.version_purchase / version — _version),
// WIDGET.process_model_record (doc.params version / versions / plan_approval_admin_only / plan_docs_roles — pm_versions, admin_only_on, PDB.roles_cfg); WIDGET.record — ни один из двух.
// Тот же класс widget_REPORT2, что у signal_chains_batch / stock_cells_batch (лёгкий запрос там уже живой). Поэтому summary / history шлют урезанную запись (readLight_record: без _doc,
// doc.viewList / viewParams / подсказок, doc.params без data_layout2 / data_layout2_fields / conditional_format / option_groups) и без fast_entry; workspace / ПМ — целиком.
// plan_decision (запись, и dry) — НЕ трогается: ответ записи перечитывает отчёт (select) и полной записи ему нужно. Выключатель fe.ux.planApprovalLight (дефолт ВКЛ; false — прежний запрос)
export const PLAN_APPROVAL_LIGHT_FLAG = 'fe.ux.planApprovalLight'
export const PLAN_APPROVAL_LIGHT_METHODS = [METHODS.summary, METHODS.history]
export function planApproval_lightOn(setting) {
    try { return typeof setting !== 'function' || setting(PLAN_APPROVAL_LIGHT_FLAG, true) !== false } catch (e) { return true }
}
// поля action запроса: { record: урезанная копия, fast_entry: undefined } (mainStore.get_widget_to_transfer берёт action.record как есть); не summary / history, флаг выкл., нет записи — {}
export function planApproval_lightFields(method, record, setting) {
    if (!PLAN_APPROVAL_LIGHT_METHODS.includes(method) || !isObjLoose(record) || !planApproval_lightOn(setting)) return {}
    return { record: readLight_record(record), fast_entry: undefined }
}
function isObjLoose(x) { return !!(x && typeof x === 'object' && !Array.isArray(x)) }

// IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки)
// Кэш ответа сводки на 30 с на грид (ключ — грид + версия + позиции отбора): повторное наведение / пересборка шапки / новый экземпляр грида того же виджета не шлют запрос.
// Сброс: любой plan_decision без dry (planApproval_decide, до отправки и по ответу) и повторный load_data грида (AttrGrid). Ответ с ошибкой / без ответа — не кэшируется.
// Выключатель fe.ux.planApprovalSummaryCache (дефолт ВКЛ; false — запрос на каждую сборку, как до правки). Счётчики — window.__planApprovalStat { sent, cacheHit, light }
export const PLAN_APPROVAL_SUMMARY_CACHE_FLAG = 'fe.ux.planApprovalSummaryCache'
export const PLAN_APPROVAL_SUMMARY_TTL_MS = 30000
const SUMMARY_CACHE_MAX = 64
const _summaryCache = new Map()
export function planApproval_summaryCacheOn(setting) {
    try { return typeof setting !== 'function' || setting(PLAN_APPROVAL_SUMMARY_CACHE_FLAG, true) !== false } catch (e) { return true }
}
// ключ грида: id виджета + имя поля грида
export function planApproval_gridKey(grid) {
    const w = grid && grid.WIDGET, a = grid && grid.attr
    return String((w && w.id) ?? '') + ':' + String((a && (a.name || a.binding)) ?? '')
}
// версия, как у бэка (_version): workspace_record params.version_purchase, иначе params.version (и doc.params.* — запись стола целиком)
export function planApproval_versionOf(wr) {
    const r = isObjLoose(wr) ? wr : {}
    const p = isObjLoose(r.params) ? r.params : {}, dp = isObjLoose(r.doc) && isObjLoose(r.doc.params) ? r.doc.params : {}
    for (const v of [p.version_purchase, dp.version_purchase, p.version, dp.version]) { const s = v == null ? '' : String(v).trim(); if (s) return s }
    return ''
}
export function planApproval_summaryKey(gridKey, version, objects) {
    return String(gridKey ?? '') + '#' + String(version ?? '') + '#' + (Array.isArray(objects) ? objects.join('|') : String(objects ?? ''))
}
// ответ кэшировать: есть plan_decision_summary без ошибки
export function planApproval_summaryCacheable(raw) {
    return isObjLoose(raw) && !String(raw.state || '').startsWith('error')
}
export function planApproval_cacheGet(key, now = Date.now(), cache = _summaryCache, ttl = PLAN_APPROVAL_SUMMARY_TTL_MS) {
    const e = cache.get(key)
    if (!e) return undefined
    if (!(now >= e.t && now - e.t < ttl)) { cache.delete(key); return undefined }
    return e.raw
}
export function planApproval_cachePut(key, raw, now = Date.now(), cache = _summaryCache) {
    if (!key || !planApproval_summaryCacheable(raw)) return false
    cache.delete(key); cache.set(key, { t: now, raw })
    while (cache.size > SUMMARY_CACHE_MAX) cache.delete(cache.keys().next().value)
    return true
}
// сброс по гриду (gridKey) или весь ('' / нет ключа); число снятых записей
export function planApproval_cacheDrop(gridKey = '', cache = _summaryCache) {
    if (!gridKey) { const n = cache.size; cache.clear(); return n }
    const pre = String(gridKey) + '#'
    let n = 0
    for (const k of [...cache.keys()]) if (k.startsWith(pre)) { cache.delete(k); n++ }
    return n
}
export function planApproval_stat(field) {
    try { if (typeof window === 'undefined') return; const s = window.__planApprovalStat = window.__planApprovalStat || { sent: 0, cacheHit: 0, light: 0 }; s[field] = (s[field] || 0) + 1 } catch (e) { /* без window */ }
}
export const DECISIONS = ['process_until', 'approve', 'confirm', 'withdraw']
export const STATES = ['autoplan', 'processed', 'approved', 'approved-changed', 'withdrawn']
export const ACTIVE = ['processed', 'approved', 'approved-changed']
export const REASON_SEGMENT = 'PLAN-DECISION-REASON'
// причины по умолчанию (= config_predefined_approval.PLAN_DECISION_REASONS бэка), пока справочник не загружен в itemsSource
export const DEFAULT_REASONS = [
    { id: 'pdr-supplier-unconfirmed', title: 'Supplier has not confirmed the batch' },
    { id: 'pdr-no-budget', title: 'No budget for the period' },
    { id: 'pdr-wait-sales-plan', title: 'Waiting for the sales plan' },
    { id: 'pdr-other', title: 'Other' },
]
const RANK = { autoplan: 0, withdrawn: 0, approved: 1, processed: 2, 'approved-changed': 3 }   // = plan_approval_v3.STATE_RANK: «худший» — больше
const ALIAS = { PO: 'PURCHASE-PLAN', DO: 'DISTR-PLAN', PLAN_purchase: 'PURCHASE-PLAN', PLAN_transfer: 'DISTR-PLAN', PLAN_consignment: 'DISTR-PLAN',
    PLAN_purchase_dev: 'PURCHASE-PLAN', PLAN_transfer_dev: 'DISTR-PLAN', PLAN_consignment_dev: 'DISTR-PLAN' }
const R_WITHDRAW = 'workflowReason-plan-withdraw'
const DECISION_OF_REASON = { 'workflowReason-plan-process-until': 'process_until', 'workflowReason-approve': 'approve', 'workflowReason-reapprove': 'confirm',
    [R_WITHDRAW]: 'withdraw', 'workflowReason-plan-edit-after-approval': 'edit', 'workflowReason-plan-autoplan-changed': 'changed' }

const isObj = (x) => !!(x && typeof x === 'object' && !Array.isArray(x))
const str = (v) => (v === undefined || v === null) ? '' : String(v).trim()
// IE 2026 11 03 / ODOO-5800 (webscm #128539 п.6, ie-dm7 #128571: право решения в сводке — may_decide): код отказа записи — решать по версии может только admin (1ult_002)
export const ADMIN_ONLY = 'admin_only'
// IE 2026 11 03 / ODOO-5800 (ie-dm7 #128964: отказ dry admin_only / unverified — окно без действия): права не удалось прочитать — показать message, повтор не предлагать
export const UNVERIFIED = 'unverified'
export function planApproval_unverifiedText(message = '') { return str(message) || t('Could not read your rights for this plan; try later or ask the administrator') }   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128964: отказ dry admin_only / unverified — окно без действия)
// IE 2026 11 03 / ODOO-5800 (webscm #128539 п.6, ie-dm7 #128571: право решения в сводке — may_decide): may_decide сегмента трёхзначно — true / false; null или поля нет (старый бэк) — ответа нет (null)
export function planApproval_mayDecide(v) { return v === true ? true : v === false ? false : null }
export function planApproval_noRightText(why) { const w = str(why); return w ? t('No right to decide: {why}', { why: w }) : t('No right to decide on this plan') }

// IE 2026 11 03 / ODOO-5800 (ie-dm7 #128341: запись решений на бэке с дефектами, «до моего письма fe.ux.planApproval на бой для пользователей НЕ включай»):
// IE 2026 11 04 / ODOO-5800 (слово Игоря через ie-dm7 #129874: дефолт ВКЛ; замок v2 — why из may_decide):
// дефолт ВКЛ (plan_approval_admin_only с ПМ 1ult_002 снят, серверный гейт may_decide — на бэке); выключить — ?fe.ux.planApproval=false в URL, localStorage feSettings или настройкой базы
// нет значения — ВКЛ; явный false ('false', 0) — ВЫКЛ; читать нечем / ошибка чтения — дефолт
export const PLAN_APPROVAL_DEFAULT = true   // IE 2026 11 04 / ODOO-5800 (слово Игоря через ie-dm7 #129874: дефолт ВКЛ; замок v2 — why из may_decide)
export function planApproval_on(setting) {   // IE 2026 11 04 / ODOO-5800 (слово Игоря через ie-dm7 #129874: дефолт ВКЛ; замок v2 — why из may_decide)
    try {
        if (typeof setting !== 'function') return PLAN_APPROVAL_DEFAULT
        const v = setting(PLAN_APPROVAL_FLAG, PLAN_APPROVAL_DEFAULT)
        if (v === undefined || v === null || v === '') return PLAN_APPROVAL_DEFAULT
        return !(v === false || v === 0 || String(v).trim().toLowerCase() === 'false' || String(v).trim() === '0')
    } catch (e) { return PLAN_APPROVAL_DEFAULT }
}

// 'PURCHASE-PLAN' | 'PO' | мера вида 'PLAN_purchase' → сегмент плана снабжения; '' — не ЗП / DO
export function planApproval_segmentOf(x) {
    const s = str(x)
    if (SEGMENTS.includes(s)) return s
    return ALIAS[s] || ALIAS[s.toUpperCase()] || ''
}

// WHERE ячейки / строки ([[поле, значение]] или [{leftValue, condition, rightValue, attrs}]) → {поле: значение} (как plan_docs_balance._where_pairs: имя — после последней точки)
export function planApproval_pairs(where, out = {}) {
    for (const w of Array.isArray(where) ? where : []) {
        if (Array.isArray(w) && w.length >= 2) { const k = str(w[0]).split('.').pop(); if (k && !(k in out) && w[1] !== '' && w[1] !== null && w[1] !== undefined) out[k] = w[1]; continue }
        if (!isObj(w) || w.use === false) continue
        const lv = w.leftValue, k = str(isObj(lv) ? lv.value : lv).split('.').pop()
        const cond = str(w.condition || '=').toLowerCase()
        if (k && (cond === '=' || cond === 'in') && !(k in out)) {
            const rv = isObj(w.rightValue) ? w.rightValue.value : w.rightValue
            const vals = Array.isArray(w.attrs) && w.attrs.length
                ? w.attrs.filter(a => isObj(a) && a.use !== false).map(a => (isObj(a.rightValue) ? a.rightValue.value : a.rightValue)).filter(v => v !== '' && v !== null && v !== undefined && v !== '<isempty>')
                : (rv !== '' && rv !== null && rv !== undefined ? [rv] : [])
            if (vals.length === 1) out[k] = vals[0]
            else if (vals.length > 1) out[k] = vals
        }
        if (Array.isArray(w.WHERE)) planApproval_pairs(w.WHERE, out)
    }
    return out
}

// сегмент строки по её WHERE: plan_segment, иначе мера вида в measure_type / measure ('' — не строка ЗП / DO).
// IE 2026 11 03 / ODOO-5800 (ревью этапа B): как plan_docs_balance.segment_of бэка — только имя сегмента и меры вида PLAN_*; 'PO' / 'DO' в WHERE — тип движения 1С
// (TXN, факт), не план: короткие коды здесь не принимаются (иначе раздел и пилюля — у строк движений и в чужих отчётах)
function _whereSeg(v) {
    const s = str(v)
    return SEGMENTS.includes(s) ? s : (s.startsWith('PLAN_') && ALIAS[s]) || ''
}
export function planApproval_whereSegment(where) {
    const p = isObj(where) ? where : planApproval_pairs(where)
    for (const k of ['plan_segment', 'measure_type', 'measure']) { const s = _whereSeg(Array.isArray(p[k]) ? '' : p[k]); if (s) return s }
    return ''
}

// state / status бэка ('statusPlan-processed', 'approved-changed', …) → state; прочее — autoplan
export function planApproval_state(x) {
    const s = str(isObj(x) ? (x.state || x.status) : x).toLowerCase().replace(/^statusplan-/, '').replace(/_/g, '-')
    if (s === 'changed' || s === 'approvedchanged') return 'approved-changed'
    return STATES.includes(s) ? s : 'autoplan'
}
export function planApproval_rank(state) { return RANK[planApproval_state(state)] || 0 }
export function planApproval_worst(states) {
    let best = 'autoplan'
    for (const s of Array.isArray(states) ? states : []) { const st = planApproval_state(s); if (RANK[st] > RANK[best] || (best === 'autoplan' && st === 'withdrawn')) best = st }
    return best
}
export function planApproval_isActive(state) { return ACTIVE.includes(planApproval_state(state)) }

// 'YYYY-MM-DD' настоящей даты
export function planApproval_dateOk(d) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str(d))
    if (!m) return false
    const dt = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]))
    return dt.getUTCFullYear() === +m[1] && dt.getUTCMonth() === +m[2] - 1 && dt.getUTCDate() === +m[3]
}
// '2026-11-15' → '15.11.2026' (short — '15.11'); не дата — как есть
export function planApproval_dateText(d, short = false) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(str(d))
    return m ? (short ? m[3] + '.' + m[2] : m[3] + '.' + m[2] + '.' + m[1]) : str(d)
}
function _atText(v) { const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(str(v)); return m ? m[3] + '.' + m[2] + ' ' + m[4] + ':' + m[5] : planApproval_dateText(v, true) }

export function planApproval_segmentTitle(seg) {
    return planApproval_segmentOf(seg) === 'DISTR-PLAN' ? t('Transfer plan') : t('Purchase plan')
}
function _short(seg) { return planApproval_segmentOf(seg) === 'DISTR-PLAN' ? t('Transfers') : t('Purchases') }

export function planApproval_stateText(state, until = '') {
    switch (planApproval_state(state)) {
        case 'processed': return str(until) ? t('Processed until {date}', { date: planApproval_dateText(until) }) : t('Processed')
        case 'approved': return t('Approved')
        case 'approved-changed': return t('Changed after approval')
        case 'withdrawn': return t('Withdrawn')
        default: return t('Autoplan')
    }
}
// класс тона (кнопка / чип / пилюля): pa-tone-autoplan | processed | approved | changed | withdrawn
export function planApproval_tone(state) {
    const s = planApproval_state(state)
    return 'pa-tone-' + (s === 'approved-changed' ? 'changed' : s)
}

export function planApproval_decisionTitle(decision, until = '') {
    switch (decision) {
        case 'process_until': return str(until) ? t('Processed until {date}', { date: planApproval_dateText(until) }) : t('Processed until…')
        case 'approve': return t('Approve the whole horizon')
        case 'confirm': return t('Confirm the approval')
        case 'withdraw': return t('Withdraw approval')
        case 'history': return t('History')
        default: return str(decision)
    }
}

// ----- сводка (plan_decision_summary) и кнопка шапки -----
// IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком)
// ошибка ответа бэка (state 'error: …' / code / message) → текст для человека; '' — ошибки нет. version_not_in_pm — версия плана не из ПМ отчёта
export const VERSION_NOT_IN_PM = 'version_not_in_pm'
export const WHOLE_CODES = [ADMIN_ONLY, UNVERIFIED, VERSION_NOT_IN_PM]   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128964: отказ dry admin_only / unverified — окно без действия): коды отказа всего запроса
export function planApproval_errorText(state, code = '', message = '') {
    const st = str(state), c = str(code)
    if (c === VERSION_NOT_IN_PM || st.includes(VERSION_NOT_IN_PM)) return t('The plan version is not in the process model of the report')
    if (c === UNVERIFIED) return planApproval_unverifiedText(message)   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128964: отказ dry admin_only / unverified — окно без действия)
    if (!st.startsWith('error') && !c) return ''
    return st.startsWith('error') ? st : (str(message) || c)
}
// by_key сводки (этап C: key_id = plan_doc_id строки Баланса) → {key_id: {segment, title, state, until, rows, decided, dims, last}}
// IE 2026 11 03 / ODOO-5800 (проба p244: dims — непустые измерения ключа из KEY_DIMS, plan.md §7)
export const KEY_DIMS = ['object', 'subject_from', 'subject_to', 'subject', 'packaging', 'batch']
export function planApproval_byKey(raw) {
    const out = {}
    if (!isObj(raw)) return out
    for (const k of Object.keys(raw)) {
        const v = raw[k]
        if (!str(k) || !isObj(v)) continue
        const l = isObj(v.last) ? v.last : null
        const dims = {}   // IE 2026 11 03 / ODOO-5800 (проба p244: измерения ключа — сопоставление видимой строки плана по WHERE, planApproval_keyMatch)
        for (const f of KEY_DIMS) { const dv = str(v[f]); if (dv) dims[f] = dv }
        out[str(k)] = { segment: planApproval_segmentOf(v.segment), title: str(v.title), state: planApproval_state(v.state || v.status), until: str(v.until),
            rows: Number(v.rows) || 0, decided: v.decided === true || Number(v.decided) > 0, dims,   // IE 2026 11 03 / ODOO-5800 (проба p244: измерения ключа)
            last: l ? { state: planApproval_state(l.state), by: str(l.by), at: str(l.at), reason: str(l.reason), reasonTitle: str(l.reason_title), comment: str(l.comment), until: str(l.until) } : null }
    }
    return out
}
export function planApproval_summary(raw) {
    const r = isObj(raw) ? raw : {}
    const segs = isObj(r.segments) ? r.segments : {}
    const out = { state: str(r.state) || (Object.keys(segs).length ? 'ok' : 'empty'), off: str(r.state) === 'off', error: planApproval_errorText(r.state, r.code, r.message),   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком)
        code: str(r.code), version: str(r.version), segments: [], worst: 'autoplan', keys: 0, byKey: planApproval_byKey(r.by_key) }
    for (const seg of SEGMENTS) {
        const s = isObj(segs[seg]) ? segs[seg] : null
        if (!s) continue
        const n = (k) => Math.max(0, Number(s[k]) || 0)
        const keys = n('keys')
        const st = keys ? planApproval_state(s.state || s.status) : 'autoplan'
        const last = isObj(s.last) ? { state: planApproval_state(s.last.state), by: str(s.last.by), at: str(s.last.at), reason: str(s.last.reason), reasonTitle: str(s.last.reason_title), comment: str(s.last.comment), until: str(s.last.until) } : null
        out.segments.push({ segment: seg, title: planApproval_segmentTitle(seg), keys, state: st, untilMin: str(s.until_min), untilMax: str(s.until_max),
            counts: { autoplan: n('autoplan'), processed: n('processed'), approved: n('approved'), changed: n('approved-changed') || n('changed'), withdrawn: n('withdrawn') },
            decided: n('processed') + n('approved') + (n('approved-changed') || n('changed')), last: last && (last.at || last.by) ? last : null,
            mayDecide: planApproval_mayDecide(s.may_decide), whyNot: str(s.why) })   // IE 2026 11 03 / ODOO-5800 (webscm #128539 п.6, ie-dm7 #128571: право решения в сводке — may_decide)
        out.keys += keys
    }
    out.worst = planApproval_worst(out.segments.filter(s => s.keys).map(s => s.state))
    return out
}

// чип вида плана на кнопке: «Purchases · until 15.11», «Transfers · ✓»
export function planApproval_chip(s) {
    if (!isObj(s) || !s.keys) return null
    const tail = s.state === 'processed' ? t('until {date}', { date: planApproval_dateText(s.untilMin || s.untilMax, true) })
        : s.state === 'approved' ? '✓' : s.state === 'approved-changed' ? t('changed') : s.state === 'withdrawn' ? t('withdrawn') : t('autoplan')
    return { segment: s.segment, text: _short(s.segment) + ' · ' + tail, tone: planApproval_tone(s.state) }
}

// строка вида плана в меню: «Purchase plan — Processed until 15.11.2026 · 1 position · Supplier… · ivan 30.10 09:12»
export function planApproval_segmentLine(s, reasonTitle = (x) => x) {
    if (!isObj(s)) return ''
    const parts = [s.title + ' — ' + planApproval_stateText(s.state, s.untilMin || s.untilMax), tn(s.keys, '{n} position', '{n} positions')]
    if (s.keys > 1 && s.decided && s.decided < s.keys) parts.push(t('mixed: {a} approved · {p} processed · {c} changed · {o} autoplan', { a: s.counts.approved, p: s.counts.processed, c: s.counts.changed, o: s.counts.autoplan + s.counts.withdrawn }))
    if (s.last) {
        if (s.last.reason) parts.push(t('reason: {r}', { r: s.last.reasonTitle || reasonTitle(s.last.reason) }))   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком)
        if (s.last.by || s.last.at) parts.push([s.last.by, _atText(s.last.at)].filter(Boolean).join(' '))
    }
    return parts.join(' · ')
}

// пункты меню вида плана (без заголовка): approve — не все позиции утверждены; process_until — всегда; confirm — есть approved-changed; withdraw — есть решение
export function planApproval_actionsOf(s) {
    if (!isObj(s) || !s.keys) return []
    const out = []
    if (s.counts.approved < s.keys) out.push('approve')
    out.push('process_until')
    if (s.counts.changed) out.push('confirm')
    if (s.decided) out.push('withdraw')
    out.push('history')
    return out
}

// IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): подпись кнопки шапки как в прототипе (раздел 1) — чипы видов плана и «Plan approval ▾»;
// wj-menu.header — innerHTML, поэтому текст экранирован; ширина задаётся подписью, наведение меняет только цвет (стили — AttrMenu.vue, .pa-hdr)
const _esc = (v) => String(v === undefined || v === null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
export function planApproval_headerHtml(chips, label = '') {   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 03.11: «Сделай более лаконичный заголовок или иконку. Для формы меню утверждения»): компактная кнопка ~45 px — иконка утверждения, по точке на вид плана (цвет — худшее состояние), ▾; полный текст — в Alt-подсказке (uiHelpNow), label — только для чтения экрана
    const dots = (Array.isArray(chips) ? chips : []).filter(isObj).map(c => `<span class="pa-dot ${_esc(c.tone)}" data-pa-chip="${_esc(c.segment)}" data-pa-text="${_esc(c.text)}"></span>`).join('')
    return `<span class="pa-hdr" aria-label="${_esc(label || t('Plan approval'))}"><i class="pi pi-verified pa-hdr-icon"></i>${dots}<i class="pi pi-angle-down pa-hdr-caret"></i></span>`
}

// IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — кнопка шапки после выбора пункта): обёртка @mescius/wijmo.vue2.input (WjMenuBehavior) на itemClicked
// ставит value = selectedValue, а сеттер value зовёт _updateHeader(): «this.control.header=this._definedHeader||""» — подпись, поставленная мимо пропа header, стирается (кнопка 14 px, пустая).
// Защита: AttrMenu передаёт подпись пропом :header (тогда _definedHeader = подпись) и после выбора пункта / закрытия списка возвращает её этой функцией. Возврат — true, если подпись пришлось вернуть
export function planApproval_headerKeep(menu, html) {
    if (!menu || typeof html !== 'string' || !html) return false
    try { if (String(menu.header || '').trim()) return false; menu.header = html; return true } catch (e) { return false }   // непустая подпись (в т. ч. перестроенная innerHTML) — не трогаем: сравнение строк с innerHTML ненадёжно
}

const ICON = { approve: 'pi-check', process_until: 'pi-calendar', confirm: 'pi-check-circle', withdraw: 'pi-undo', history: 'pi-history' }

// кнопка-меню шапки (AttrMenu командной панели грида); summary — planApproval_summary | null (идёт загрузка); ctx {source_name, binding, reasons, today}
export function planApproval_menu(summary, ctx = {}) {
    const base = { name: 'button-plan-approval-menu', attr_type: 'AttrMenu', autoGeneratedButton: true, showCommandTitle: true, uiHelp: 'planApproval.menu' }   // подпись с чипами видна на кнопке
    const item = (o) => { const a = { attr_type: 'AttrButton', command: 'executeVueObjMethod', method: 'planApproval_run', uiHelp: 'planApproval.menu', ...o }
        if (str(ctx.source_name)) a.source_name = ctx.source_name
        if (str(ctx.binding)) a.binding = ctx.binding
        return a }
    if (!isObj(summary)) return { ...base, title: t('Plan approval'), tooltip: t('Plan approval'), cssClass: 'pa-btn pa-btn-labelled pa-tone-autoplan', headerHtml: planApproval_headerHtml([]), pa_chips: [], uiHelpNow: t('Loading…'), attrs: [{ name: 'button-pa-loading', attr_type: 'AttrButton', title: t('Loading…'), disabled: true }] }
    const segs = summary.segments.filter(s => s.keys)
    const chips = segs.map(planApproval_chip).filter(Boolean)
    const reasons = planApproval_reasons(ctx.reasons)
    const rTitle = (id) => (reasons.find(r => r.id === id) || {}).title || id
    const attrs = []
    for (const s of segs) {
        if (attrs.length) attrs.push({ title: '-' })
        attrs.push({ name: 'button-pa-head-' + s.segment, attr_type: 'AttrButton', title: planApproval_segmentLine(s, rTitle), disabled: true, cssClass: 'pa-menu-head ' + planApproval_tone(s.state) })
        if (s.mayDecide === false) attrs.push({ name: 'button-pa-noright-' + s.segment, attr_type: 'AttrButton', title: planApproval_noRightText(s.whyNot), disabled: true, cssClass: 'pa-menu-noright' })   // IE 2026 11 03 / ODOO-5800 (webscm #128539 п.6, ie-dm7 #128571: право решения в сводке — may_decide): решать нельзя — команды решений скрыты, History остаётся
        for (const d of planApproval_actionsOf(s)) {
            if (s.mayDecide === false && d !== 'history') continue
            const a = item({ name: 'button-pa-' + d + '-' + s.segment, title: d === 'process_until' ? t('Processed until…') : d === 'confirm' ? t('Confirm the approval') : d === 'withdraw' ? t('Withdraw approval') : d === 'approve' ? t('Approve') : t('History'),
                cssClass: 'pi p-button-white ' + ICON[d], pa_segment: s.segment, pa_decision: d })
            Object.assign(a, planApproval_inputOf(d, { reasons, today: ctx.today, keys: s.keys }))
            attrs.push(a)
        }
    }
    if (!segs.length) attrs.push({ name: 'button-pa-empty', attr_type: 'AttrButton', title: summary.off ? t('Plan approval is switched off') : (summary.error || t('No purchase or transfer plan positions in the report')), disabled: true })
    const title = t('Plan approval')   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 03.11: «Сделай более лаконичный заголовок или иконку. Для формы меню утверждения»): подпись кнопки — одно слово (меню ≡, перемер шапки); состояние видов — точками и в Alt-подсказке
    let uiHelpNow = segs.length ? segs.map(s => planApproval_segmentLine(s, rTitle) + (s.mayDecide === false ? ' · ' + (s.whyNot ? planApproval_noRightText(s.whyNot) : t('no right to decide')) : '')).join('; ')   // IE 2026 11 04 / ODOO-5800 (слово Игоря через ie-dm7 #129874: дефолт ВКЛ; замок v2 — why из may_decide): причина отказа — и в «now» ассистента   // IE 2026 11 03 / ODOO-5800 (webscm #128539 п.6, ie-dm7 #128571: право решения в сводке — may_decide)
        : (summary.off ? t('Plan approval is switched off') : (summary.error || t('No purchase or transfer plan positions in the report')))
    if (summary.error && segs.length) uiHelpNow = '⚠ ' + summary.error + '; ' + uiHelpNow   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком): ошибка сводки (версия не из ПМ) — пометкой в Alt, кнопка остаётся
    else if (summary.error) uiHelpNow = '⚠ ' + uiHelpNow
    return { ...base, title, tooltip: t('Plan approval'), cssClass: 'pa-btn pa-btn-labelled ' + planApproval_tone(summary.worst) + (summary.error ? ' pa-err' : ''), pa_error: summary.error || '', headerHtml: planApproval_headerHtml(chips), pa_chips: chips, uiHelpNow, attrs }   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): без иконки-глифа на хосте (.pi ставил шрифт primeicons подписи), подпись и чипы — headerHtml
}

// поля окна ввода (store.confirmInput) для решений с обязательными полями: process_until — дата, причина (одна), комментарий; withdraw — комментарий
export function planApproval_inputOf(decision, ctx = {}) {
    if (decision === 'process_until') {
        return { confirm: t('Months up to the date are fixed from the autoplan; after the date the autoplan stays live. A reason and a comment are required.'),
            confirm_input: { field: 'comment', label: t('Comment'), value: '', required: true, date: { field: 'until', label: t('Processed until'), value: str(ctx.today) },
                options: planApproval_reasons(ctx.reasons).map(r => ({ field: 'reason', value: r.id, label: r.title })), exclusive: true, optionsRequired: true } }
    }
    if (decision === 'withdraw') return { confirm: t('The plan returns to the autoplan; the saved edits stay in the history. A comment is required.'), confirm_input: { field: 'comment', label: t('Comment'), value: '', required: true } }
    return {}
}

// справочник причин: записи itemsSource['PLAN-DECISION-REASON'] ({data: [{id, title}]} | [{id, title}]) без архивных, иначе умолчания (подписи — t())
export function planApproval_reasons(src) {
    const list = Array.isArray(src) ? src : (isObj(src) && Array.isArray(src.data) ? src.data : null)
    const out = (list || []).filter(r => isObj(r) && str(r.id) && r.archived !== true && r.use !== false).map(r => ({ id: str(r.id), title: str(r.title) || str(r.id) }))
    return out.length ? out : DEFAULT_REASONS.map(r => ({ id: r.id, title: t(r.title) }))
}

// ----- запись решения -----
// обязательные поля (как plan_approval_v3.validate): '' — можно отправлять
export function planApproval_validate(decision, f = {}) {
    const x = isObj(f) ? f : {}
    if (!DECISIONS.includes(decision)) return t('Choose the decision')
    if (decision === 'process_until') {
        if (!planApproval_dateOk(x.until)) return t('Set the date until which the plan is processed')
        if (!str(x.reason)) return t('Choose the reason of the decision')
        if (!str(x.comment)) return t('A comment is required')
    }
    if (decision === 'withdraw' && !str(x.comment)) return t('A comment is required')
    return ''
}

export function planApproval_scopeObjects(objects, segment) {
    const objs = [...new Set((Array.isArray(objects) ? objects : []).map(str).filter(Boolean))]
    const seg = planApproval_segmentOf(segment)
    return objs.length && seg ? { objects: objs, segment: seg } : null
}

// params метода plan_decision → {params} | {error}
export function planApproval_request(decision, scope, f = {}, dry = true) {
    const why = planApproval_validate(decision, f)
    if (why) return { error: why }
    if (!isObj(scope) || !(scope.where || scope.keys || scope.objects)) return { error: t('No plan rows found for the decision') }
    const x = isObj(f) ? f : {}
    const params = { decision, scope, dry: !!dry }
    if (decision === 'process_until') { params.until = str(x.until); params.reason = str(x.reason) }
    if (str(x.comment)) params.comment = str(x.comment)
    if (str(x.reason) && !params.reason) params.reason = str(x.reason)
    if (Array.isArray(x.months) && x.months.length === 2) params.months = x.months.map(str)
    return { params }
}

// IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): preview.title бэка — supply_flat.title_of(key) = id измерений через « · »
// (object · subject_from · subject_to …: GUID 1С, проба p239). Названия — из уже загруженных данных отчёта: store.itemsSource[*].ids (словари Link-колонок), поля
// строк «<поле>-title» (shownTitle), DataMap колонок. Не найдено — часть остаётся как есть (честно, без догадки)
export const GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
export function planApproval_titleResolver(src = {}) {
    const its = isObj(src.itemsSource) ? src.itemsSource : null
    const maps = (Array.isArray(src.dataMaps) ? src.dataMaps : []).filter(m => m && typeof m.getDisplayValue === 'function')
    const memo = new Map()
    let byRow = null
    const rowMap = () => {
        if (byRow) return byRow
        byRow = new Map()
        const rows = Array.isArray(src.rows) ? src.rows : []
        const lim = Math.min(rows.length, Number(src.limit) || 20000)
        for (let i = 0; i < lim; i++) {
            const it = rows[i]
            if (!isObj(it)) continue
            for (const k of Object.keys(it)) {
                if (!k.endsWith('-title')) continue
                const id = it[k.slice(0, -6)], tt = str(it[k])
                if (typeof id === 'string' && id && tt && tt !== id && !byRow.has(id)) byRow.set(id, tt)
            }
        }
        return byRow
    }
    return (id) => {
        const k = str(id)
        if (!k) return ''
        if (memo.has(k)) return memo.get(k)
        let out = ''
        if (its) {
            for (const seg of Object.keys(its)) {
                const ids = isObj(its[seg]) && isObj(its[seg].ids) ? its[seg].ids : null
                const rec = ids && ids[k]
                const tt = isObj(rec) ? str(rec.title || rec.name) : ''
                if (tt && tt !== k) { out = tt; break }
            }
        }
        if (!out) out = rowMap().get(k) || ''
        if (!out) for (const m of maps) { try { const v = str(m.getDisplayValue(k)); if (v && v !== k) { out = v; break } } catch (e) { /* DataMap без значения */ } }
        memo.set(k, out)
        return out
    }
}
// служебное название позиции (« · »-список id) → названия; titleOf — planApproval_titleResolver (нет — как есть)
// IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком): бэк отдаёт title названиями — подстановка только у частей, похожих на id (GUID или слово без пробелов с цифрой), прочее — как есть
export function planApproval_looksLikeId(v) {
    const s = str(v)
    return !!s && (GUID_RE.test(s) || (/^[A-Za-z0-9_.:-]+$/.test(s) && /\d/.test(s)))
}
export function planApproval_humanTitle(title, titleOf) {
    const s = str(title)
    if (!s || typeof titleOf !== 'function') return s
    const parts = s.split(' · ')
    if (!parts.some(planApproval_looksLikeId)) return s   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком)
    return parts.map(p => { const v = str(p); if (!planApproval_looksLikeId(v)) return p; let tt = ''; try { tt = str(titleOf(v)) } catch (e) { tt = '' } return tt || v }).join(' · ')
}

// ответ plan_decision → {ok, message, dry, keys, rows, preview: [{key, title, segment, stateFrom, stateText, months}], refused: [{key, title, why}]}; titleOf — названия вместо id (planApproval_humanTitle)
export function planApproval_result(raw, dry = false, titleOf = null) {
    const r = isObj(raw) ? raw : {}
    const preview = (Array.isArray(r.preview) ? r.preview : []).filter(isObj).map(p => ({ key: str(p.key_id), title: planApproval_humanTitle(str(p.title) || str(p.key_id), titleOf), segment: str(p.segment),
        stateFrom: planApproval_state(p.state_from), stateText: planApproval_stateText(p.state_from), months: Array.isArray(p.months) ? p.months.length : (Number(p.months) || 0) }))
    // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком): refused[].code; version_not_in_pm — текст для человека; partial — записано N позиций, стоп на позиции X
    const vText = () => t('The plan version is not in the process model of the report')
    const refused = (Array.isArray(r.refused) ? r.refused : []).filter(isObj).map(x => ({ key: str(x.key), title: planApproval_humanTitle(str(x.title) || str(x.key), titleOf),
        code: str(x.code), why: str(x.code) === VERSION_NOT_IN_PM ? vText() : (str(x.why) || (str(x.code) === ADMIN_ONLY ? t('Only an administrator can decide on this plan version') : str(x.code) === UNVERIFIED ? planApproval_unverifiedText() : '')) }))   // IE 2026 11 03 / ODOO-5800 (webscm #128539 п.6, ie-dm7 #128571: право решения в сводке — may_decide): admin_only без why — текстом; IE 2026 11 03 / ODOO-5800 (ie-dm7 #128964: отказ dry admin_only / unverified — окно без действия): unverified без why — текстом
    // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128964: отказ dry admin_only / unverified — окно без действия): отказ всего запроса — r.code верхнего уровня или refused без key / title (admin_only, unverified, version_not_in_pm) и в dry, и в записи:
    //   whole — причина текстом (message / why; admin_only и unverified без текста — t-текст фронта), без окна подтверждения и без «повторить», не «сбой»
    const wholeRef = refused.find(x => x.code && !x.key && !x.title) || null
    const code = str(r.code) || ((refused.find(x => x.code === VERSION_NOT_IN_PM) || wholeRef || {}).code || '')
    const ok = r.ok === true
    const partial = r.partial === true && !dry
    const whole = !ok && !partial && !!(WHOLE_CODES.includes(code) || wholeRef)   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128964: отказ dry admin_only / unverified — окно без действия)
    const nKeys = Array.isArray(r.keys) ? r.keys.length : (Number(r.keys) || 0)
    let message = str(r.message) || (ok ? '' : t('The decision is not saved'))
    if (code === VERSION_NOT_IN_PM) message = vText()
    else if (whole) {   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128964: отказ dry admin_only / unverified — окно без действия)
        const w = (wholeRef && wholeRef.code === code ? wholeRef : refused.find(x => x.code === code && !x.key && !x.title)) || wholeRef || {}
        const raw = str(r.message) || str(w.why)
        message = code === UNVERIFIED ? planApproval_unverifiedText(raw) : (raw || (code === ADMIN_ONLY ? t('Only an administrator can decide on this plan version') : t('The decision is not saved')))
    } else if (partial) {
        const stop = refused[0] || {}
        message = tn(nKeys, 'Saved {n} position, stopped at the position {title}', 'Saved {n} positions, stopped at the position {title}', { title: stop.title || stop.key || '?' }) + (stop.why ? ': ' + stop.why : '')
    }
    // отказ хотя бы по одной позиции (не версия) — решение не записано целиком: окно показывает список и не даёт записать
    const blocked = !ok && !partial && !whole && refused.some(x => x.key || x.title)   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128964: отказ dry admin_only / unverified — окно без действия): отказ всего запроса — не окно списка позиций
    const why = [...new Set(refused.map(x => x.why).filter(Boolean))].slice(0, 3).join('; ')   // IE 2026 11 04 / ODOO-5800 (слово Игоря через ie-dm7 #129874: дефолт ВКЛ; замок v2 — why из may_decide): причины отказа позиций (замок нового согласования и пр.)
    if (blocked && why && !str(r.message)) message = t('The decision is not saved') + ': ' + why   // IE 2026 11 04 / ODOO-5800 (слово Игоря через ie-dm7 #129874: дефолт ВКЛ; замок v2 — why из may_decide): ответ без message — не общий текст, а причина
    return { ok, message, why, dry: !!dry, decision: str(r.decision), state: str(r.state), code, partial, blocked, whole,   // IE 2026 11 04 / ODOO-5800 (слово Игоря через ie-dm7 #129874: дефолт ВКЛ; замок v2 — why из may_decide)
        keys: nKeys || preview.length, rows: Number(r.rows) || 0, preview, refused }
}

// IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): подписи кнопок окна подтверждения — «Cancel» и действие решения (не «Ні» / «Так»)
export function planApproval_acceptLabel(decision) {
    switch (decision) {
        case 'approve': return t('Approve')
        case 'process_until': return t('Mark processed')
        case 'withdraw': return t('Withdraw')
        case 'confirm': return t('Confirm')
        default: return t('Save the decision')
    }
}
export function planApproval_confirmLabels(decision) { return { acceptLabel: planApproval_acceptLabel(decision), rejectLabel: t('Cancel') } }

// текст подтверждения по ответу dry: решение, число позиций, список (до max), отказы
export function planApproval_previewText(res, decision, until = '', max = 8) {
    if (!isObj(res)) return ''
    const n = res.preview.length
    const head = planApproval_decisionTitle(decision, until) + ': ' + tn(n, '{n} plan position', '{n} plan positions')
    const list = res.preview.slice(0, max).map(p => p.title + ' (' + p.stateText + (p.months ? ', ' + tn(p.months, '{n} month', '{n} months') : '') + ')')
    if (n > max) list.push(t('and {n} more', { n: n - max }))
    const parts = [head + (list.length ? ' — ' + list.join('; ') : '')]
    if (res.blocked) {   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком): отказ целиком — список отказов, вопроса о записи нет
        const rl = res.refused.slice(0, max).map(x => (x.title || x.key) + (x.why ? ': ' + x.why : ''))
        if (res.refused.length > max) rl.push(t('and {n} more', { n: res.refused.length - max }))
        parts.push(tn(res.refused.length, 'Nothing is saved: {n} position is refused', 'Nothing is saved: {n} positions are refused', {}) + ' — ' + rl.join('; '))
        return parts.join('. ')
    }
    if (res.refused.length) parts.push(tn(res.refused.length, '{n} position is skipped: {why}', '{n} positions are skipped: {why}', { why: res.refused[0].why }))
    parts.push(t('Save the decision?'))
    return parts.join('. ')
}

// вызов метода чтения (summary / history): ответ нужен только вызывающему (команда ответа снимается — как у cell_passport)
// IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239):
//   dry plan_decision — уведомление ответа (TERMINAL бэка «… (preview)») тостом не показывается: у dry только окно подтверждения (хук стора _muteNotification);
//   запрос упал без ответа (HTTP-ошибка, обрыв, отказ роли) — cb(null) один раз (хуки _onResponse(null) / _onAbort): вызывающий снимает «занято»
export function planApproval_muteDry(answer) { return !!(isObj(answer) && isObj(answer.plan_decision)) }
export function planApproval_call(grid, method, params, cb) {
    const store = grid && grid.store
    const p = isObj(params) ? params : {}
    let settled = false
    const fin = (answer) => { if (settled) return; settled = true; if (typeof cb === 'function') cb(answer || null) }
    if (!store || typeof store.executeWidgetMethod !== 'function') { fin(null); return false }
    const action = { command: 'executeWidgetMethod', method, params: p,
        record_sendToBackend_exclude: ['_doc'], widget_sendToBackend_exclude: ['view'], no_del_last_backend_action: true,
        _response_callback: (answer) => { if (answer) { answer.command = ''; delete answer.updates } fin(answer) },
        _onResponse: (a) => { if (a === null) fin(null) }, _onAbort: () => fin(null) }
    if (method === METHODS.decide && p.dry === true) action._muteNotification = planApproval_muteDry
    const light = planApproval_lightFields(method, grid.WIDGET && grid.WIDGET.record, (k, d) => (typeof store.setting === 'function' ? store.setting(k, d) : d))   // IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки)
    if ('record' in light) { Object.assign(action, light); planApproval_stat('light') }   // IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки)
    if (method === METHODS.summary) planApproval_stat('sent')   // IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки)
    try { store.executeWidgetMethod({ WIDGET: grid.WIDGET }, action) } catch (e) { fin(null); return false }
    return true
}

// решение: dry → подтверждение списка позиций (req.confirm(text, accept)) → настоящий вызов на виджете (ответ несёт данные отчёта — перечитывание штатным updateDoc)
// req {decision, scope, form, confirm, note, done(res)}; false — не отправлено (ошибка — в note / done)
export function planApproval_decide(grid, req) {
    const r = isObj(req) ? req : {}
    const note = typeof r.note === 'function' ? r.note : () => {}
    let finished = false   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): итог — ровно один раз (ответ / ошибка запроса / отмена окна)
    const done = (x) => { if (finished) return; finished = true; if (typeof r.done === 'function') r.done(x) }
    const q = planApproval_request(r.decision, r.scope, r.form, true)
    if (q.error) { note(q.error, 'warning'); done({ ok: false, message: q.error, stage: 'validate' }); return false }
    const store = grid && grid.store
    if (!store || typeof store.executeWidgetMethod !== 'function') { done({ ok: false, message: t('The decision is not saved'), stage: 'validate' }); return false }
    planApproval_call(grid, METHODS.decide, q.params, (answer) => {
        const res = planApproval_result(answer && answer.plan_decision, true, r.titleOf)
        if (res.blocked) {   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком): dry ok:false с отказами — окно со списком позиций и отказов, кнопка действия недоступна, записи нет
            const cancel = () => done({ ...res, message: '', stage: 'cancel' })   // why — причина отказа (форма ячейки оставляет её под кнопками)   // IE 2026 11 04 / ODOO-5800 (слово Игоря через ie-dm7 #129874: дефолт ВКЛ; замок v2 — why из may_decide)
            if (typeof r.confirm === 'function') r.confirm(planApproval_previewText(res, r.decision, r.form && r.form.until), cancel, cancel, r.decision, { blocked: true })
            else { note(res.message, 'warning'); done({ ...res, stage: 'dry' }) }
            return
        }
        if (res.whole) { note(res.message, 'warning'); done({ ...res, stage: 'dry' }); return }   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128964: отказ dry admin_only / unverified — окно без действия): отказ всего запроса — причина уведомлением, окна с кнопкой действия нет, повтора нет
        if (!res.ok) { note(answer ? res.message : t('No answer from the server'), 'warning'); done({ ...res, message: answer ? res.message : t('No answer from the server'), stage: 'dry' }); return }
        const go = () => {
            const real = { ...q.params, dry: false }
            const target = (grid.WIDGET && grid.WIDGET.vueObj) || grid
            planApproval_cacheDrop(planApproval_gridKey(grid))   // IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки): запись решения — сводка этого грида перечитывается
            const lost = () => { const m = t('No answer from the server'); note(m, 'warning'); done({ ok: false, message: m, stage: 'write' }) }
            try {
                store.executeWidgetMethod(target, { command: 'executeWidgetMethod', method: METHODS.decide, params: real, record_sendToBackend_exclude: ['_doc'], widget_sendToBackend_exclude: ['view'],
                    _response_callback: (ans) => { planApproval_cacheDrop(planApproval_gridKey(grid)); if (finished) return; const fin = planApproval_result(ans && ans.plan_decision, false, r.titleOf); note(fin.message, fin.ok ? 'success' : 'warning'); done({ ...fin, stage: 'write' }) },   // partial — сообщение «записано N, стоп на X» (planApproval_result)   // IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки): по ответу записи — сброс кэша сводки
                    _onResponse: (a) => { if (a === null) lost() }, _onAbort: lost })
            } catch (e) { lost() }
        }
        const text = planApproval_previewText(res, r.decision, r.form && r.form.until)
        if (typeof r.confirm === 'function') r.confirm(text, go, () => done({ ...res, stage: 'cancel' }), r.decision)
        else done({ ...res, stage: 'cancel' })   // IE 2026 11 03 / ODOO-5800 (ревью этапа B): без окна подтверждения запись не уходит
    })
    return true
}

// ----- история (plan_decision_history) -----
function _eventState(e) {
    if (str(e.reason) === R_WITHDRAW) return 'withdrawn'
    return planApproval_state(e.status_to)
}
// события → строки списка раздела формы ячейки (новые сверху)
// IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком): category_title / reason_title событий (язык пользователя) вместо id; поля нет (прежний бэк) — справочник, иначе id
function _catTitle(e, rs) {
    if (str(e.category_title)) return str(e.category_title)
    const id = str(e.category)
    if (!id) return ''
    const f = rs.find(r => r.id === id)
    return f ? f.title : ('category_title' in e ? '' : id)
}
export function planApproval_historyRows(events, reasons) {
    const rs = planApproval_reasons(reasons)
    return (Array.isArray(events) ? events : []).filter(isObj).map((e, i) => {
        const st = _eventState(e), dec = DECISION_OF_REASON[str(e.reason)] || ''
        const what = dec === 'changed' ? t('Autoplan changed') : dec === 'edit' ? t('Edited after approval') : (!dec && str(e.reason_title)) ? str(e.reason_title) : planApproval_stateText(st, e.until_date)   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком)
        return { key: str(e.at) + ':' + i, at: str(e.at), atText: _atText(e.at), state: st, tone: planApproval_tone(dec === 'changed' ? 'approved-changed' : st), text: what,
            who: str(e.source) === 'recalc' ? t('Recalculation') : str(e.user), comment: str(e.comment), reason: _catTitle(e, rs), reasonTitle: str(e.reason_title), months: Array.isArray(e.months) ? e.months.map(str) : [] }
    }).sort((a, b) => (a.at < b.at ? 1 : a.at > b.at ? -1 : 0))
}

// события → список единиц окна History (store.approvalHistory_open: [{unit, title, status, events}]) — по ключу плана
export function planApproval_historyUnits(events, opts = {}) {
    const rs = planApproval_reasons(opts.reasons)
    const by = new Map()
    for (const e of (Array.isArray(events) ? events : []).filter(isObj)) {
        const k = str(e.key_id) || '-'
        if (!by.has(k)) by.set(k, [])
        by.get(k).push(e)
    }
    const out = []
    for (const [k, evs] of by) {
        const sorted = evs.slice().sort((a, b) => (str(a.at) < str(b.at) ? 1 : -1))
        const st = _eventState(sorted[0])
        out.push({ unit: k, title: (typeof opts.titleOf === 'function' && str(opts.titleOf(k))) || k, status: 'statusPlan-' + st, status_title: planApproval_stateText(st, sorted[0].until_date),
            events: sorted.map((e, i) => {
                const est = _eventState(e), dec = DECISION_OF_REASON[str(e.reason)] || ''
                return { id: k + ':' + i, at: str(e.at), user_name: str(e.source) === 'recalc' ? '' : str(e.user), user_ref: str(e.source) === 'recalc' ? { system: true } : undefined,
                    reason: str(e.reason), reason_title: dec === 'changed' ? t('Autoplan changed') : dec === 'edit' ? t('Edited after approval') : planApproval_decisionTitle(dec, e.until_date) || str(e.reason_title) || str(e.reason),   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком)
                    status_from: str(e.status_from), status_from_title: planApproval_stateText(e.status_from), status_to: str(e.status_to), status_to_title: planApproval_stateText(est, e.until_date),
                    comment: str(e.comment), category: _catTitle(e, rs), changed_periods: Array.isArray(e.months) ? e.months.map(str) : [], source: str(e.source) }
            }) })
    }
    return out
}

// ----- раздел формы ячейки -----
// состояние ключа ячейки по последнему событию истории (новое сверху); событий нет — autoplan
export function planApproval_cellState(events) {
    const evs = (Array.isArray(events) ? events : []).filter(e => isObj(e) && DECISION_OF_REASON[str(e.reason)] !== 'edit')
        .sort((a, b) => (str(a.at) < str(b.at) ? 1 : str(a.at) > str(b.at) ? -1 : 0))
    const ev = evs[0]
    if (!ev) return { state: 'autoplan', until: '', at: '' }
    const st = _eventState(ev)
    return { state: st, until: st === 'processed' || st === 'approved-changed' ? str(ev.until_date) : '', at: str(ev.at) }
}

// модель раздела: segment — сегмент строки; history — ответ plan_decision_history (null — идёт загрузка)
export function planApproval_formModel(opt = {}) {
    const seg = planApproval_segmentOf(opt.segment)
    if (!seg) return null
    const h = isObj(opt.history) ? opt.history : null
    const events = h && Array.isArray(h.events) ? h.events : []
    const cs = planApproval_cellState(events)
    const stateText = planApproval_stateText(cs.state, cs.until)
    // IE 2026 11 03 / ODOO-5800 (webscm #128539 п.6, ie-dm7 #128571: право решения в сводке — may_decide): право решения — из сводки кнопки шапки (opt.summary = planApproval_summary грида); нет сводки / ответа — null, форма как прежде
    const ss = isObj(opt.summary) && Array.isArray(opt.summary.segments) ? opt.summary.segments.find(x => x && x.segment === seg) : null
    const mayDecide = ss ? planApproval_mayDecide(ss.mayDecide) : null
    return { segment: seg, mayDecide, noRightText: mayDecide === false ? planApproval_noRightText(ss.whyNot) : '', title: planApproval_segmentTitle(seg), loading: !h, off: !!(h && h.state === 'off'), error: h ? planApproval_errorText(h.state, h.code, h.message) : '',   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком): версия не из ПМ — текстом
        state: cs.state, until: cs.until, stateText, tone: planApproval_tone(cs.state), locked: planApproval_isActive(cs.state),
        canConfirm: cs.state === 'approved-changed', canWithdraw: planApproval_isActive(cs.state),
        rows: planApproval_historyRows(events, opt.reasons).slice(0, Number(opt.max) || 12), n: events.length,
        summary: stateText + (events.length ? ' · ' + tn(events.length, '{n} decision', '{n} decisions') : '') }
}

// форма раздела {choice: approve | process_until | withdraw | confirm, until, reason, comment} → решение + поля
export function planApproval_formDecision(form) {
    const f = isObj(form) ? form : {}
    const d = str(f.choice)
    return DECISIONS.includes(d) ? { decision: d, form: { until: str(f.until), reason: str(f.reason), comment: str(f.comment) } } : null
}

// ----- пилюля строки Баланса -----
// IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком): поле строки по имени — как есть, иначе с префиксом пути («узел.decision_state», «2026-11-01::decision_state»: имя после последней «.» / «:» / «/»),
// иначе пары WHERE строки (_DLRow.where — как plan_doc_id = fkey у cell_passport), иначе _DLRow[имя]. undefined — поля в строке нет, '' — есть, пустое
const _FIELD_CACHE = new WeakMap()
function _tail(k) { const p = String(k).split(/[.:/]/); return p[p.length - 1] }
export function planApproval_rowField(dataItem, name) {
    const it = isObj(dataItem) ? dataItem : null
    if (!it || !name) return undefined
    const has = (v) => v !== undefined && v !== null && typeof v !== 'object'
    if (has(it[name])) return str(it[name])
    let keys = _FIELD_CACHE.get(it)
    if (!keys) { keys = Object.keys(it).filter(k => k !== name && !k.endsWith('-title') && (k.includes('.') || k.includes(':') || k.includes('/'))); _FIELD_CACHE.set(it, keys) }
    let found
    for (const k of keys) {
        if (_tail(k) !== name || !has(it[k])) continue
        const v = str(it[k])
        if (v) return v   // у всех месяцев одно значение (состояние ключа) — первое непустое
        found = ''
    }
    if (found !== undefined) return found
    const d = isObj(it._DLRow) ? it._DLRow : null
    if (d) {
        const p = planApproval_pairs(d.where)
        if (has(p[name])) return str(p[name])
        if (has(d[name])) return str(d[name])
    }
    return undefined
}
// decision строки (DS-PLAN-DOCS этапа C: dataItem.decision {state, until} | decision_state / decision_until — в т. ч. с префиксом пути | _DLRow.decision); нет — null.
// Поле decision_state есть, но пустое — {state: 'autoplan', empty: true} (решения нет — пилюли нет; запасной путь by_key остаётся)
export function planApproval_rowDecision(dataItem) {
    const it = isObj(dataItem) ? dataItem : null
    if (!it) return null
    const d = isObj(it.decision) ? it.decision : (isObj(it._DLRow) && isObj(it._DLRow.decision) ? it._DLRow.decision : null)
    if (d && str(d.state)) return { state: planApproval_state(d.state), until: str(d.until) }
    const ds = planApproval_rowField(it, 'decision_state')
    if (ds) return { state: planApproval_state(ds), until: planApproval_rowField(it, 'decision_until') || '' }
    if (ds === '') return { state: 'autoplan', until: '', empty: true }
    return null
}
// IE 2026 11 03 / ODOO-5800 (проба p244: сводку перечитывают после каждого решения, строки Баланса — нет): состояние пилюли — by_key сводки по plan_doc_id строки (ключ есть в сводке)
// → decision_state / decision_until строки (поле есть и пустое — пилюли нет) → ключи by_key, подходящие по WHERE строки и предков (where: пары / список WHERE; видимые строки плана
// Баланса DM без plan_doc_id и decision_state, planApproval_keyMatch) → сводка вида плана, если в отборе ОДНА позиция этого вида; autoplan / неизвестно — null (пилюли нет)
export function planApproval_rowState(dataItem, segment, summary, where = null) {   // IE 2026 11 03 / ODOO-5800 (проба p244: порядок источников, where)
    const own = planApproval_rowDecision(dataItem)
    const bk = isObj(summary) && isObj(summary.byKey) ? summary.byKey : null
    const kid = bk ? planApproval_rowField(dataItem, 'plan_doc_id') : ''   // IE 2026 11 03 / ODOO-5800 (проба p244: сводка — первой)
    const seg = planApproval_segmentOf(segment)
    let st = null, n = 1
    if (kid && bk[kid]) st = { state: bk[kid].state, until: bk[kid].until, source: 'key' }   // IE 2026 11 03 / ODOO-5800 (проба p244: свежее строки после решения)
    else if (own && !own.empty) st = { state: own.state, until: own.until, source: 'row' }
    else if (own && own.empty) st = null   // поле этапа C есть и пустое — решения у ключа нет
    else {
        const m = bk && seg && where ? planApproval_keyMatch(summary, seg, where) : null   // IE 2026 11 03 / ODOO-5800 (проба p244: видимая строка плана по WHERE)
        if (m) { st = { state: m.state, until: m.until, source: 'where', allActive: m.allActive }; n = m.n }
        else if (isObj(summary) && seg) {
            const s = (summary.segments || []).find(x => x.segment === seg)
            if (s && s.keys === 1) st = { state: s.state, until: s.untilMax || s.untilMin, source: 'summary' }
        }
    }
    if (!st || st.state === 'autoplan') return null
    const text = planApproval_stateText(st.state, st.until) + (n > 1 ? ' · ' + tn(n, '{n} position', '{n} positions') : '')   // IE 2026 11 03 / ODOO-5800 (проба p244: несколько позиций — худшее и число)
    const locked = planApproval_isActive(st.state) && st.allActive !== false   // IE 2026 11 03 / ODOO-5800 (проба p244: замок — только если решение действует у всех подошедших позиций)
    return { state: st.state, until: st.until, source: st.source, n, text, tone: planApproval_tone(st.state), locked }
}
// IE 2026 11 03 / ODOO-5800 (проба p244: видимые строки плана Баланса DM — без plan_doc_id и decision_state, они только у скрытых строк): индекс by_key по виду плана и объекту —
// один раз на сводку (WeakMap по объекту сводки; сводку перечитывают — индекс строится заново)
const _KEY_INDEX = new WeakMap()
export function planApproval_keyIndex(summary) {
    if (!isObj(summary) || !isObj(summary.byKey)) return null
    let ix = _KEY_INDEX.get(summary)
    if (ix) return ix
    ix = new Map()
    for (const [k, v] of Object.entries(summary.byKey)) {
        const o = isObj(v) && isObj(v.dims) ? v.dims.object : ''
        if (!o || !v.segment) continue
        const ik = v.segment + '|' + o
        if (!ix.has(ik)) ix.set(ik, [])
        ix.get(ik).push({ key: k, dims: v.dims, state: v.state, until: v.until })
    }
    _KEY_INDEX.set(summary, ix)
    return ix
}
// ключи by_key вида seg, подходящие строке по парам WHERE (planApproval_pairs: имя — хвост после последней «.»): объект обязателен; прочие измерения ключа (KEY_DIMS) —
// если поле есть в WHERE строки, значение совпадает (IN — входит в список), нет поля — не ограничивает. Ничего — null; иначе {n, state (худшее, как у сводки вида), until, allActive, keys}
export function planApproval_keyMatch(summary, segment, where) {   // IE 2026 11 03 / ODOO-5800 (проба p244: видимая строка плана по WHERE)
    const ix = planApproval_keyIndex(summary)
    const seg = planApproval_segmentOf(segment)
    if (!ix || !ix.size || !seg) return null
    const p = isObj(where) ? where : planApproval_pairs(where)
    const vals = (f) => { const v = p[f]; return v === undefined ? null : (Array.isArray(v) ? v : [v]).map(str).filter(Boolean) }
    const objs = vals('object')
    if (!objs || !objs.length) return null
    const hit = []
    for (const o of new Set(objs)) {
        for (const c of ix.get(seg + '|' + o) || []) {
            let ok = true
            for (const f of KEY_DIMS) {
                if (f === 'object' || !c.dims[f]) continue
                const rv = vals(f)
                if (rv && rv.length && !rv.includes(c.dims[f])) { ok = false; break }
            }
            if (ok) hit.push(c)
        }
    }
    if (!hit.length) return null
    const state = planApproval_worst(hit.map(h => h.state))
    const until = hit.filter(h => h.state === state).map(h => str(h.until)).filter(Boolean).sort().pop() || ''
    return { n: hit.length, state, until, allActive: hit.every(h => planApproval_isActive(h.state)), keys: hit.map(h => h.key) }
}
// IE 2026 11 03 / ODOO-5800 (проба p244: заголовок окна History — id позиции): название единицы окна — byKey[k].title сводки (id внутри — через titleOf, planApproval_humanTitle),
// иначе titleOf(k), иначе '' (окно покажет id)
export function planApproval_unitTitle(summary, titleOf = null) {
    const bk = isObj(summary) && isObj(summary.byKey) ? summary.byKey : {}
    return (k) => {
        const id = str(k)
        const tt = isObj(bk[id]) ? str(bk[id].title) : ''
        if (tt) return planApproval_humanTitle(tt, titleOf)
        if (typeof titleOf === 'function') { try { return str(titleOf(id)) } catch (e) { return '' } }
        return ''
    }
}
// HTML пилюли (escape — экранирование стора): замок pi-lock у действующего решения
export function planApproval_pillHtml(rs, escape = (v) => String(v)) {
    if (!isObj(rs)) return ''
    return `<span class="status-chip pa-pill ${escape(rs.tone)}" data-pa-state="${escape(rs.state)}" data-pa-source="${escape(rs.source || '')}">${rs.locked ? '<i class="pi pi-lock pa-lock"></i>' : ''}${escape(rs.text)}</span>`
}

// IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху): обход строк дерева в глубину (порядок строк грида) — sourceCollection дерева
// childItemsPath держит только верхний уровень, строки плана лежат во вложенных узлах. childPath '' — плоский список, как прежде; limit — предел строк обхода
// (вместе с вложенными); fn(it) === true — стоп. Узел, встреченный дважды (цикл ссылок), не обходится повторно. childPath массивом — имя по уровню, как у wijmo
export function planApproval_walkRows(items, childPath = '', limit = 20000, fn = null) {
    const lim = Number(limit) > 0 ? Number(limit) : 20000
    const pathAt = (lvl) => (Array.isArray(childPath) ? str(childPath[Math.min(lvl, childPath.length - 1)]) : str(childPath))
    const seen = new Set()
    const stack = [[Array.isArray(items) ? items : [], 0, 0]]
    let n = 0
    while (stack.length && n < lim) {
        const top = stack[stack.length - 1]
        if (top[1] >= top[0].length) { stack.pop(); continue }
        const it = top[0][top[1]++]
        if (!isObj(it) || seen.has(it)) continue
        seen.add(it); n++
        if (typeof fn === 'function' && fn(it) === true) return n
        const cp = pathAt(top[2])
        const ch = cp ? it[cp] : null
        if (Array.isArray(ch) && ch.length) stack.push([ch, 0, top[2] + 1])
    }
    return n
}
// объекты строк отчёта (WHERE строки _DLRow.where и поле object) — скоуп кнопки шапки; limit — предел перебора строк; childPath — дети узла дерева (обход на любой глубине)
export function planApproval_objectsOfRows(items, limit = 20000, childPath = '') {   // IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху)
    const out = new Set()
    planApproval_walkRows(items, childPath, limit, (it) => {   // IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху)
        const p = planApproval_pairs(isObj(it._DLRow) ? it._DLRow.where : null)
        const o = p.object !== undefined ? p.object : it.object
        if (Array.isArray(o)) o.forEach(v => { if (str(v)) out.add(str(v)) })
        else if (str(o) && typeof o !== 'object') out.add(str(o))
    })
    return [...out]
}
// есть ли в отчёте строки ЗП / DO (по WHERE строки и отбору узла раскладки) — кнопка нужна только Балансу; childPath — строки плана и во вложенных узлах дерева
export function planApproval_hasPlanRows(items, limit = 20000, childPath = '') {   // IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху)
    let hit = false
    planApproval_walkRows(items, childPath, limit, (it) => {   // IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху)
        const d = isObj(it._DLRow) ? it._DLRow : null
        if (d && (planApproval_whereSegment(d.where) || planApproval_whereSegment(d.where_block))) hit = true
        return hit
    })
    return hit
}
// строки дерева списком (обход planApproval_walkRows) — для словаря названий окна подтверждения
export function planApproval_flatRows(items, childPath = '', limit = 20000) {   // IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху)
    if (!childPath || (Array.isArray(childPath) && !childPath.length)) return Array.isArray(items) ? items : []
    const out = []
    planApproval_walkRows(items, childPath, limit, (it) => { out.push(it) })
    return out
}
